module.exports = __webpack_public_path__ + "static/media/buy_req_rent_9.cd049806.png";